<script>
	import BasketList from "../../lib/components/BasketList.svelte";
	import ModalRenderer from "../../lib/components/ModalRenderer.svelte";
	import Footer from "../../lib/components/Footer.svelte";
	import { Basket } from "../../lib/stores/basket";
	let scrollPosition = 0;
	import Sidebar from '../../lib/components/SideBar.svelte';
	import FilterBar from '../../lib/components/FiltersBar.svelte';
	let sidebar_show = false;
	let FilterBar_show = false;
	import GTM from '../../utils/gtm';

	GTM.page();
</script>
<svelte:window bind:scrollY={scrollPosition} />
<header id="header" class="fixed-top inner-header" class:header-alt={scrollPosition>0}>
	<div class="container-fluid">
		<div class="row">
			<button class="menu-btn" on:click={() => sidebar_show = !sidebar_show}>
				<img src="/images/menu.png" class="img-fluid" alt="Menu">
			</button>
			<div class="col-xl-12 d-flex align-items-center justify-content-center position-relative">
				<a href="/" class="logo"><img src="/images/logo.png" alt="" class="img-fluid"></a>
				<div class="search">
					<a href="#">
						<img src="/images/search.png" alt="search">
					</a>
				</div>
			</div>
			<div class="text-right cart animate__animated animate__slideInDown animate__faster">
				<a href="#" on:click|preventDefault={e => Basket.open() }>
					{#if $Basket.items.length > 0}
						<sup class="cart-count">
							{$Basket.items.reduce((t,c) => t+c.pricelist_by_avl_sizes.reduce((to,cr) => to+(cr.quantity ? parseInt(cr.quantity) : 0),0),0)}
						</sup>
					{/if}
					<img class="cart-icon" src="/images/cart.png" alt="cart">
				</a>
			</div>
		</div>
		<Sidebar bind:show={sidebar_show} />
	</div>
</header>
<section class="banner-section">
	<div class="container">
		<h1>
			<slot name="heading"></slot>
		</h1>
	</div>
</section>
<section id="" class="page-content">
	<div class="container">
		<div class="content-box">
            <slot></slot>
        </div>
    </div>
</section>
<ModalRenderer/>
<BasketList/>
<Footer />
<a href="https://wa.me/919606020090" class="whatsapp-btn" target="_blank">
	<img src="/images/whatsapp-01.png" class="img-fluid" alt="whatsapp">
</a>
<button class="filters-btn" on:click={() => FilterBar_show = !FilterBar_show}>
	<img src="/images/filter.png" class="img-fluid" alt="Filter">
</button>
<FilterBar bind:show={FilterBar_show} />
<style lang="scss">
	// @import "../../scss/styles.scss";

	.cart {
		font-size: 2em;
		position: absolute;
		right: 20px;
		top: 15px;
	}

	.menu-btn {
		position: absolute;
		z-index: 99;
		background: none;
		border: none;
		top: 20px;
		left: 20px;
	}

	.menu-btn img {
		width: 32px;
		height: 32px;
	}

	.filters-btn {
		position: fixed;
		background: none;
		border: none;
		bottom: 40px;
		right: 10px;
		z-index: 99;
	}

	.filters-btn img {
		width: 32px;
		height: 32px;
		z-index: 99;
	}

	.search {
		position: absolute;
		right: 70px;
		top: 50%;
		transform: translateY(-50%);
	}

	.search img {
		max-width: 30px;
		height: 30px;
	}

	.cart a {
		position: relative;
	}

	.cart a sup {
		color: #000;
	}

	.cart-count {
		background: #fff;
		width: 20px;
		height: 20px;
		border-radius: 50%;
		position: absolute;
		right: -10px;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 13px;
	}

	.whatsapp-btn {	
		position: fixed;
		background: none;
		border: none;
		bottom: 35px;
		left: 10px;
		z-index: 99;
	}
	
	.whatsapp-btn img {
		width: 32px;
		height: 32px;
		z-index: 99;
	}

	.cart-icon {
		max-width: 30px;
		height: 30px
	}

    .content-box {
		padding: 24px 24px;
		background: rgba(130, 130, 130, 0.3) none repeat scroll 0 0;
		border-color: rgba(255, 255, 255, 0.4) rgba(60, 60, 60, 0.4) rgba(60, 60, 60, 0.4) rgba(255, 255, 255, 0.4);
		border-image: none;
		border-radius: 25px;
		color: #444;
		box-shadow: 8px 8px 8px #888888;
	}

    .page-content {
		font-family: var(--primary-font);
		padding: 40px 0;
	 	// background-image: url("/images/web-pattern-gold-body.png");
	}

    .banner-section {
		background: rgba(0, 0, 0, 0.6);
		min-height: 250px;
		padding-top: 80px;
	}

	h1 {
		font-family: 3em;
		font-family: var(--primary-font);
		font-weight: 600;
		margin-top: 50px;
	}

</style>